import { Component, OnInit, ɵConsole } from '@angular/core';
import { LoadingController, NavController, AlertController, Platform, ModalController, ToastController } from '@ionic/angular';
import { PassaObjetoService } from '../../services/passa-objeto.service';
import { DadosService } from '../../services/dados/dados.service';
import * as moment from 'moment';
import { NavigationExtras } from '@angular/router';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/user/auth.service';
import { NovoExamePage } from './../../exame/novo-exame/novo-exame.page'
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {
    HttpClient,
    HttpEvent,
    HttpResponse,
    HttpHandler,
    HttpErrorResponse,
    HttpEventType,
    // tslint:disable-next-line: import-spacing
} from "@angular/common/http";

@Component({
    selector: 'app-novo-saude',
    templateUrl: './novo-saude.page.html',
    styleUrls: ['./novo-saude.page.scss'],
})



export class NovoSaudePage implements OnInit {
    codUsuario: any;
    usuarioDados: any;
    isLoading = false;
    public loading: HTMLIonLoadingElement;
    saudeObj: any = {};
    showSpinner = true
    logado = false;
    btSalvarAtivo = false;

    minEventDate: string;
    maxEventDate: string;
    maxEventDateContato: string;
    minEventDateContato: string;

    mostraData = false;
    mostraDataContato = false;
    mostraDataTeste = false;

    comInstituicoes = false;

    public testeCovid19 = [];
    public sintomas = [];
    public gruposRisco = [];
    public atividadesRisco = [];
    public mobilidadeAtv = [];
    public documentosSI = [];
    public autorizacoes = []
    form$: any;
    usuario: any;
    formArrayRespostas: any;
    formJsonPush = {};
    formDataOut = new FormData();
    respostas: any;
    mostraDatePicker = true
    tipoExame = ''
    cadastrarExame = false
    exameFormData: any
    constructor(
        public loadingController: LoadingController,
        public toastCtrl: ToastController,
        public alertController: AlertController,
        private router: Router,
        private dadosService: DadosService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private passaObjetoService: PassaObjetoService,
        public modalController: ModalController,
        private authService: AuthService,
    ) {
        var dateMin = new Date();
        var monthMin = (dateMin.getMonth())
        var dayMin = (dateMin.getDate())
        var yearMin = (dateMin.getFullYear());
        this.maxEventDate = new Date(yearMin, monthMin, dayMin).toISOString().substring(0, 10);
        this.minEventDate = new Date(2020, 1, 1).toISOString().substring(0, 10);
        this.maxEventDateContato = new Date(yearMin, monthMin, dayMin).toISOString().substring(0, 10);
        this.minEventDateContato = new Date(2020, 1, 1).toISOString().substring(0, 10);

        this.saudeObj = {
            dataSintoma: this.maxEventDate,
            dataContato: this.maxEventDateContato,
            dataTeste: this.maxEventDate,
            instituicoesDiligencias: "",
            documentosEnviados: ""
        }
        this.limpaForm()
    }

    ngOnInit() {
        this.limpaForm()
        // console.log(this.authService.usuario)
        this.authService.usuario.subscribe(usr => {
            if (usr !== undefined && usr.toString() !== "UNAUTHORIZED") {
                this.logado = true
                this.usuario = usr
                // console.log(this.usuario)
                this.pegaRespostas()
            }
        })
        this.route.queryParams.subscribe(params => {
            let action = params['action'];
            if (action !== undefined) {
                if (action === 'update') {
                    this.pegaRespostas();
                }
            }
        });
    }

    pegaRespostas() {
        let configUrl = environment.apiUrl + '/ListAll';
        this.http.get(configUrl)
            .subscribe(data => {
                if (data) {
                    this.form$ = data;
                    // console.log(this.form$)
                    this.montaRespostas(this.form$)
                }
            });
    }


    async chamaAlerta(message, buttons) {
        const alert = await this.alertController.create({
            message,
            buttons
        });
        await alert.present();
    }


    async presentToast(message, color, duration) {
        const toast = await this.toastCtrl.create({
            message,
            mode: 'ios',
            position: 'middle',
            color,
            duration,
        });
        toast.present();
    }


    async montaRespostas(respostasBd) {
        this.loading = await this.loadingController.create();
        this.respostas = respostasBd.content
        this.respostas.forEach(resposta => {
            if (resposta.codp === 1) {
                resposta.Respostas.forEach(resp => {
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.testeCovid19.push(resp)
                });
            }
            if (resposta.codp === 3) {
                resposta.Respostas.forEach(resp => {
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.sintomas.push(resp)
                });
            }
            if (resposta.codp === 5) {
                resposta.Respostas.forEach(resp => {
                    // console.log(resp)
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.gruposRisco.push(resp)
                });
                // console.log(resposta)
            }
            if (resposta.codp === 6) {
                resposta.Respostas.forEach(resp => {
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.atividadesRisco.push(resp)
                });
            }
            if (resposta.codp === 8) {
                resposta.Respostas.forEach(resp => {
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.mobilidadeAtv.push(resp)
                });
            }
            if (resposta.codp === 10) {
                resposta.Respostas.forEach(resp => {
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.autorizacoes.push(resp)
                });
            }
            // console.log(this.autorizacoes)
            if (resposta.codp === 11) {
                resposta.Respostas.forEach(resp => {
                    resp.isChecked = false
                    resp.cor = "primary"
                    this.documentosSI.push(resp)
                });
            }
        });
        // console.log(this.respostas)
        this.showSpinner = false
    }





    // ----- apresenta e dispensa o loader -------------------------------------------------------------------------------------------
    async present() {
        this.isLoading = true;
        return await this.loadingController.create({
            //duration: 5000,
        }).then(a => {
            a.present().then(() => {
                // console.log('presented');
                if (!this.isLoading) {
                    a.dismiss().then(() => console.log('abort presenting'));
                }
            });
        });
    }
    async dismiss() {
        this.btSalvarAtivo = false;
        this.saudeObj = {};
        this.saudeObj = {
            dataSintoma: this.maxEventDate,
            dataContato: this.maxEventDate,
            instituicoesDiligencias: "",

        }
        this.mostraData = false;
        this.mostraDataContato = false;
        this.mostraDataTeste = false;
        // console.log(this.saudeObj)



        this.isLoading = false;
        this.loadingController.dismiss().then(() => console.log('dismissed'));
        let navigationExtras: NavigationExtras = { state: { id: this.codUsuario } };
        // this.router.navigate(['/perfil-usuario'], navigationExtras);
        //  return this.navCtrl.navigateBack('/perfil-usuario/' + this.idAtual);
    }
    // ----- FIM apresenta e dispensa o loader -------------------------------------------------------------------------------------------




    //------------apresenta o alerta de SEM OUTROS--------------------------------------------------------------------------------------
    async alertaOutros(header, message) {
        const alert = await this.alertController.create({
            animated: true,
            backdropDismiss: false,
            header,
            message,
            buttons: [
                {
                    cssClass: 'primary',
                    role: 'cancel',
                    text: 'Entendi',
                    handler: () => {
                        //// console.log('Confirm Okay');
                        this.btSalvarAtivo = true;
                        // this.navCtrl.navigateBack('/saude-lista');
                    }
                }
            ]
        });
        await alert.present();
        return
    }
    //------------ FIM apresenta o alerta de SEM OUTROS--------------------------------------------------------------------------------------



    async exameModal() {
        this.mostraDatePicker = false
        this.passaObjetoService.setDestn({ aPartirDoForm: true })
        // console.log(exmVac)
        const modal = await this.modalController.create({
            component: NovoExamePage,
            cssClass: 'half-modal',
            backdropDismiss: true,
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
        console.log(data);

        if (data) {
            this.exameFormData = data.formExame
            this.tipoExame = data.tipoExame
            this.mostraDatePicker = false
            this.cadastrarExame = false
            this.saudeObj.dataTeste = data.dtExame
        } else {
            this.exameFormData = undefined
            this.mostraDatePicker = false
            this.mostraDataTeste = false
            this.cadastrarExame = true
        }

    }
    alteraTeste(teste) {
        console.log(teste)
        if (teste.codResp === 37) { // Não fiz o teste
            this.mostraDataTeste = false;
            this.mostraDatePicker = false
            this.exameFormData = undefined
        } else {
            this.mostraDataTeste = true;
            this.mostraDatePicker = true
        }

        if (teste.codResp === 3 || teste.codResp === 4) { // Teste positivo ou negativo --- abrir tela de exame
            this.exameModal();
        } else {
            this.cadastrarExame = false
            this.exameFormData = undefined
        }


    }

    alteraSintomas(sintoma) {
        if (sintoma.codResp === 15) {
            this.sintomas.forEach((sintomaF: any) => {
                if (sintomaF.codResp !== 15) {
                    sintomaF.isChecked = "false"
                }
            })
            this.mostraData = false;
        }
        if (sintoma.codResp !== 15) {
            this.sintomas.forEach((sintomaF: any) => {
                if (sintomaF.codResp === 15) {
                    sintomaF.isChecked = "false"
                }
            })
            this.mostraData = true;
        }
    }

    alteraAtvRisco(atividade) {
        //// console.log(atividade)
        if (atividade.codResp === 26) {
            this.atividadesRisco.forEach((atividadeF: any) => {
                if (atividadeF.codResp !== 26) {
                    atividadeF.isChecked = "false"
                }
            })
            this.mostraDataContato = false;
        }

        if (atividade.codResp !== 26) {
            this.atividadesRisco.forEach((atividadeF: any) => {
                if (atividadeF.codResp === 26) {
                    atividadeF.isChecked = "false"
                }
            })
            this.mostraDataContato = true;
        }

    }

    alteraGrupoRisco(risco) {
        //// console.log(atividade)
        if (risco.codResp === 22) {
            this.gruposRisco.forEach((riscoF: any) => {
                if (riscoF.codResp !== 22) {
                    riscoF.isChecked = "false"
                }
            })
        }
        if (risco.codResp !== 22) {
            this.gruposRisco.forEach((riscoF: any) => {
                if (riscoF.codResp === 22) {
                    riscoF.isChecked = "false"
                }
            })
        }
        if (risco.codResp === 23) {
            this.gruposRisco.forEach((riscoF: any) => {
                if (riscoF.codResp !== 23) {
                    riscoF.isChecked = "false"
                }
            })
        }
        if (risco.codResp !== 23) {
            this.gruposRisco.forEach((riscoF: any) => {
                if (riscoF.codResp === 23) {
                    riscoF.isChecked = "false"
                }
            })
        }
    }

    alteraMobilidadeAtv(atividade) {
        if (atividade.codResp === 31) {
            if (this.comInstituicoes == true) {
                this.comInstituicoes = false;
            }
            else {
                this.comInstituicoes = true;
            }
        }
    }



    montaSaudeObj() {
        var saudeForm = this.saudeObj
        console.log(saudeForm)

        if (this.cadastrarExame === true) {
            this.exameModal()
            return
        }

        this.formArrayRespostas = []
      
        this.formArrayRespostas.push( {
            codpergunta: 1,
            codresposta:saudeForm.testeCovid19.codResp,  //  pergunta 1 teste covid
            dateResp: dataFimTeste,
            stringResp: ""
        })

        var dataFimSintoma = moment(saudeForm["dataSintoma"]).format('YYYY-MM-DD');
        var dataFimContato = moment(saudeForm["dataContato"]).format('YYYY-MM-DD');
        var dataFimTeste = moment(saudeForm["dataTeste"]).format('YYYY-MM-DD');
        console.log(dataFimTeste)


        if (this.mostraDataTeste === false && this.exameFormData === undefined) {
            dataFimTeste = "";
        } else {
            this.formArrayRespostas.push( {
                codpergunta: 2,
                codresposta: 0,  // pergunta 2 Data pergunta 1 teste covid
                dateResp: dataFimTeste,
                stringResp: ""
            })
        }

        if (this.mostraData === false) {
            dataFimSintoma = "";
        } else {
            this.formArrayRespostas.push(  {
                codpergunta: 4,
                codresposta: 0,  // pergunta 4 Data sintoma
                dateResp: dataFimSintoma,
                stringResp: ""
            })
        }

        if (this.mostraDataContato === false) {
            dataFimContato = "";
        } else {
            this.formArrayRespostas.push(  {
                codpergunta: 7,
                codresposta: 0,  // pergunta 4 Data contato com alguém infectado...
                dateResp: dataFimContato,
                stringResp: ""
            })
        }

        if(this.comInstituicoes == true){
            this.formArrayRespostas.push(  {
                codpergunta: 9,
                codresposta: 0,  // pergunta 9 Nome das instituições em que participou de inspeção ou diligência
                dateResp: "",
                stringResp: saudeForm["instituicoesDiligencias"]
            }) 
        }

        let sintomasFinal = []
        this.sintomas.forEach((sintoma: any) => {
            if (sintoma.isChecked === true) {
                sintomasFinal.push({ cod: sintoma.codResp, label: sintoma.res })
                this.formArrayRespostas.push(
                    {
                        codpergunta: 3,
                        codresposta: sintoma.codResp,  // pergunta 2 Nos últimos 14 dias você teve algum desses sintomas 
                        dateResp: "",
                        stringResp: ""
                    }
                )
            }
        })

           

        if (sintomasFinal.length === 0) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher ao menos um campo de cada pergunta"
            this.alertaOutros(header, message)
            return
        }



        let riscoFinal = []
        this.gruposRisco.forEach((risco: any) => {
            if (risco.isChecked === true) {

                riscoFinal.push(risco.codResp)
                this.formArrayRespostas.push(
                    {
                        codpergunta: 5,
                        codresposta: risco.codResp,  // pergunta 5 Voce se enquadra em algum desses Grupos de Risco... 
                        dateResp: "",
                        stringResp: ""
                    }
                )
            }

        })
        if (riscoFinal.length === 0) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher as informações relativas ao grupo de risco"
            this.alertaOutros(header, message)
            return
        }



        let contatoFinal = []
        this.atividadesRisco.forEach((atividade: any) => {
            if (atividade.isChecked === true) {
                contatoFinal.push(atividade.codResp)
                this.formArrayRespostas.push(
                    {
                        codpergunta: 6,
                        codresposta: atividade.codResp,  // pergunta 6 Voce teve contato, nos últimos 14 dias, com alguém infectado... 
                        dateResp: "",
                        stringResp: ""
                    }
                )
            }

        })
        if (contatoFinal.length === 0) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher ao menos um campo de cada pergunta"
            this.alertaOutros(header, message)
            return
        }

        let atividadeFinal = []
        this.mobilidadeAtv.forEach((atividade: any) => {
            if (atividade.isChecked === true) {
                atividadeFinal.push(atividade.codResp)
                this.formArrayRespostas.push(
                    {
                        codpergunta: 8,
                        codresposta: atividade.codResp,  // pergunta 8 Quanto à modalidade das atividades desenvolvidas por você atualmente: 
                        dateResp: "",
                        stringResp: ""
                    }
                )
            }
        })
        if (atividadeFinal.length === 0) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher ao menos um campo de cada pergunta"
            this.alertaOutros(header, message)
            return
        }


        if (saudeForm["testeCovid19"] === undefined) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher o campo relativo ao teste do COVID-19"
            this.alertaOutros(header, message)
            return
        }
        if (saudeForm["autorizoUso"] === undefined) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher o campo relativo ao uso de suas informações"
            this.alertaOutros(header, message)
            return
        } else {
            this.formArrayRespostas.push(
                {
                    codpergunta: 10,
                    codresposta: saudeForm["autorizoUso"].codResp,  // pergunta 8 Quanto à modalidade das atividades desenvolvidas por você atualmente: 
                    dateResp: "",
                    stringResp: ""
                }
            )
        }


        if (saudeForm["documentosEnviados"] === undefined) {
            let header = 'Campo obrigatório!'
            let message = "Você deve preencher o campo relativo ao envio de documentos, ao final do formulário"
            this.alertaOutros(header, message)
            return
        } else {
            this.formArrayRespostas.push(
                {
                    codpergunta: 11,
                    codresposta: saudeForm["documentosEnviados"].codResp,  // pergunta 11 Documentos: 
                    dateResp: "",
                    stringResp: ""
                }
            )
        }

        //  return
        this.mostraData = false;
        sintomasFinal = []
        contatoFinal = []
        atividadeFinal = []
        this.limpaForm()
        this.gravaSaude()
    }

    limpaForm() {
        // console.log(this.testeCovid19)

        this.sintomas.forEach((sintoma: any) => {
            sintoma.isChecked = false
        })
        this.atividadesRisco.forEach((atividade: any) => {
            atividade.isChecked = false
        })

        this.mobilidadeAtv.forEach((mob: any) => {
            mob.isChecked = false
        })
        this.testeCovid19.forEach((mob: any) => {
            mob.isChecked = false
        })

        this.gruposRisco.forEach((mob: any) => {
            mob.isChecked = false
        })
        this.documentosSI.forEach((mob: any) => {
            mob.isChecked = false
        })

        this.saudeObj.documentosEnviados == ""
    }
    async gravaSaude() {

        let form = {
            cdmatricula: this.usuario.cdmatricula,
            respostas: this.formArrayRespostas
        }

        let temExame = false
        if (this.exameFormData !== undefined && this.exameFormData !== null) {
            temExame = true
        }
        console.log("form", form)
      //  return
        this.formDataOut.append("form", JSON.stringify(form));
        this.btSalvarAtivo = false
        this.loading = await this.loadingController.create();
        await this.loading.present();
        let _self = this
        let configUrl = environment.apiUrl + '/saveForm';
        let message = "Salvando formulário!"
        this.presentToast(message, 'primary', 1000)

        this.dadosService.salvaFormUser(this.formDataOut)
            .subscribe((event) => {
                // console.log(event)
                this.formDataOut.delete("form");
                if (event['cod'] == 200) {
                    this.loading.dismiss().then(() => {

                        let message = "Formulário salvo com sucesso!"
                        this.presentToast(message, 'success', 2000)
                        if (temExame == true) {
                            this.salvaExame(this.exameFormData)
                        } else {
                            this.router.navigateByUrl('/saude-lista');
                        }


                    });
                }
                if (event['cod'] == 500) {
                    this.loading.dismiss().then(() => {
                        let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
                        let buttons = [{ text: 'Ok', role: 'cancel' }]
                        this.chamaAlerta(message, buttons)
                    });
                }
            }
                ,
                err => {
                    this.formDataOut.delete("form");
                    this.loading.dismiss()
                    console.log(err)
                    if (err.statusText == "Unknown Error") {
                        let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
                        let buttons = [{ text: 'Ok', role: 'cancel' }]
                        this.chamaAlerta(message, buttons)
                    }


                },
                () => console.log('ok')
            );
    }



    async salvaExame(exameFrom) {
        console.log(exameFrom)
        let message = "Salvando exame!"
        this.presentToast(message, 'primary', 1000)
        this.loading = await this.loadingController.create();

        await this.loading.present();

        this.dadosService.salvaExameUser(exameFrom)
            .subscribe((event) => {
                if (event['cod'] == 200) {
                    this.loading.dismiss().then(() => {
                        let message = "Exame salvo com sucesso!"
                        this.presentToast(message, 'success', 2000)
                        this.router.navigateByUrl('/saude-lista');
                    });
                }
                if (event['cod'] == 500) {
                    this.loading.dismiss().then(() => {
                        let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
                        let buttons = [{ text: 'Ok', role: 'cancel' }]
                        this.chamaAlerta(message, buttons)
                    });
                }
            }
                ,
                err => {
                    this.loading.dismiss()
                    // console.log(err)
                    if (err.statusText == "Unknown Error") {
                        let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
                        let buttons = [{ text: 'Ok', role: 'cancel' }]
                        this.chamaAlerta(message, buttons)
                    }
                    if (err.status == 400) {
                        let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
                        let buttons = [{ text: 'Ok', role: 'cancel' }]
                        this.chamaAlerta(message, buttons)
                    }
                    if (err.status == 500) {
                        let message = "O arquivo excedeu o tamanho máximo permitido (6MB). Reduza o tamanho da imagem e tente novamente."
                        let buttons = [{ text: 'Ok', role: 'cancel' }]
                        this.chamaAlerta(message, buttons)
                    }

                },
                () => console.log('ok')
            );



    }

}
